var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.54 17.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.78,5.48H.67A.68.68,0,0,1,0,4.85a.71.71,0,0,1,.42-.74,1.12,1.12,0,0,1,.31-.05h1.5A.7.7,0,0,1,3,4.71c.09.49.18,1,.28,1.47a1.24,1.24,0,0,0,0,.16H7.08a.2.2,0,0,1,.22.15,5.06,5.06,0,0,0,4,3.16,4.43,4.43,0,0,0,2-.14l.11,0c-.2.58-.39,1.15-.6,1.69a.62.62,0,0,1-.62.38H4.29l.25,1.28h8.07a.67.67,0,0,1,.69.44.71.71,0,0,1-.58,1H4.14c-.49,0-.71-.19-.81-.71s-.28-1.35-.41-2c-.37-1.95-.73-3.89-1.1-5.83C1.81,5.62,1.79,5.56,1.78,5.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8,16.57A1.36,1.36,0,0,1,4.46,18a1.37,1.37,0,0,1-1.3-1.42A1.35,1.35,0,0,1,4.5,15.16,1.35,1.35,0,0,1,5.8,16.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.11,15.16a1.41,1.41,0,0,1,0,2.81,1.36,1.36,0,0,1-1.3-1.41A1.34,1.34,0,0,1,12.11,15.16Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.09,
    cy: 4.45,
    r: 4.45
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.454ffa89ce9a002a7c2ae322691d0de7.svg";
export { ForwardRef as ReactComponent };